import { useEffect, useRef, useState } from 'react';
import { Box, Loader, Paper, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconLinkOff } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import { authService } from '../services/authService';
import { useAuth } from '../contexts/AuthContext';
import { QURILMA_SESSIYA } from '../lib/qurilma';

/**
 * `/ilova?kod=...` — SATA ilovasi panelni shu manzil bilan ochadi (spec 2026-10-15 §6.2, §8.1).
 * Kod DARHOL URL'dan olib tashlanadi (tarix, Railway HTTP logi), bir martalik — qurilma
 * sessiyasiga almashtiriladi. Token bo'lsa — `/` (qayta login shart emas), yo'q bo'lsa — `/login`.
 */
export default function Ilova() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const [xato, setXato] = useState(false);
  // StrictMode effektni ikki marta chaqiradi — kod bir martalik, ikkinchi urinish 410 berardi
  const boshlandi = useRef(false);

  useEffect(() => {
    if (boshlandi.current) return;
    boshlandi.current = true;
    const kod = new URLSearchParams(window.location.search).get('kod');
    // React Router holati (`idx`, `key`) saqlanadi — faqat URL'dan kod olib tashlanadi
    window.history.replaceState(window.history.state, '', '/ilova');
    if (!kod) {
      setXato(true);
      return;
    }
    api
      .post<{ sessiya: string }>('/qurilma/almash', { kod })
      .then(async ({ data }) => {
        localStorage.setItem(QURILMA_SESSIYA, data.sessiya);
        if (!authService.getToken()) return navigate('/login', { replace: true });
        // AuthContext `/ilova` da /auth/me chaqirmaydi (eski sessiya poygasi, I1) — foydalanuvchi (rol, ism,
        // maktab) shu yerda, YANGI sessiya bilan yangilanadi. Xato bo'lsa ham `/` ga: 401 ni u yerdagi
        // birinchi so'rov interceptor orqali hal qiladi (bu yerda — `/ilova` — token o'chirilmaydi).
        await authService.me().then((u) => { if (u?.id) updateUser(u); }).catch(() => {});
        navigate('/', { replace: true });
      })
      .catch(() => setXato(true));
  }, [navigate, updateUser]);

  return (
    <Box style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <Paper withBorder radius="lg" p="xl" maw={420} w="100%">
        {xato ? (
          <Stack align="center" ta="center" gap="sm">
            <ThemeIcon size={56} radius="xl" variant="light" color="orange"><IconLinkOff size={30} /></ThemeIcon>
            <Title order={4}>{t('qurilma.havolaEskirgan')}</Title>
          </Stack>
        ) : (
          <Stack align="center" gap="sm">
            <Loader />
            <Text c="dimmed">{t('qurilma.ochilmoqda')}</Text>
          </Stack>
        )}
      </Paper>
    </Box>
  );
}
